import { ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, ViewChildren, ViewContainerRef } from "@angular/core";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { filter, tap, take, switchMap, takeUntil, delay } from "rxjs/operators";
import { PageService } from "@services/page.service";
import { UserService } from "@services/user.service";
import { LoadingPageScreenService } from "@services/loading-page-screen.service"; 
import { CookieService } from "ngx-cookie-service";
import { CommentingService } from "./scaffold/services/commenting.service";
import { ScaffoldDialogService } from "./framework/dialog/scaffold-dialog.service";
import { PropertiesService } from "./scaffold/services/properties.service";
import {
  NotificationsService,
  NotificationStatus,
} from "./services/notifications.service";
import { ItemsService } from "./scaffold/services/items.service";
import { EnvironmentService } from "@services/environment.service";
import { combineLatest, Observable, of, Subject } from "rxjs";
import { DatadogService } from "@services/datadog.service";
import { IframeService } from "@services/iframe.service";
import { MainSidebarService } from "@services/main-sidebar.service";
import { TranslateService } from "@ngx-translate/core";
import { TranslationService } from "@services/translation.service";
import { HttpClient } from "@angular/common/http";
import { OverlayService } from "@services/overlay.service";
import { PageTitleService } from "@services/page-title.service";
import { MenuListService } from "@services/menu-list.service";
import { IntercomService } from "@services/intercom.service";
import { VerifyModalComponent } from "./account/profile/verify-modal/verify-modal.component";
import {
  NotificationMessageData,
  NotificationMessageIcon,
} from "./framework/notification-sidebar/notification-sidebar.component";
import { CognitoDomainService } from "@services/cognito-domain.service";
import { IdentityProviderService } from "./services/identity-provider.service";
import { WebSocketService } from "./services/web-socket.service";
import { TourService } from "@services/tour.service";
import { QuickHelpComponent } from "@scaffold/dialogs/quick-help/quick-help.component";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "E2-Web";
  /** Status of the top menu bar*/
  hideMenu = false;
  /** User details*/
  userInfo = null;
  /** Revious path*/
  prevPath = "";
  /** Environment Type*/
  env;
  /** State of Scaffold menu*/
  private _navState = ["collapsed", "compacted"];
  sideNavState = "collapsed";
  private cognitoDomain;
  /**Settings object for currently selected  properties item*/
  propertiesItem;
  /**Disable the properties panel if currently displayed*/
  propertiesDisabled;
  /** Content of left Scaffold menu*/
  globalLeftMenuItems = [];
  footerMenu = [];
  selectedType;
  darkLogoError = false;
  personalMenu: any[] = [
    { routerLink: "/profile", label: "Profile" },
    { routerLink: "/reset-password", label: "Reset Password" },
    { label: "Logout", command: () => this.logout(), skipLocationChange: true },
  ];

  private avoidSSORedirect: boolean = false;
  displayAutosave
  notificationStatus$: Observable<NotificationStatus>;
  activeNotificationCount: number = 0;
  instanceDetails;
  translate$: any;
  hasAddedWizardFooter = false;
  notifiedUnverifiedEmail: boolean;
  userAttributes$;
  loggedIn: any;
  cognitoSsoUrl: string;
  initalSsoAuthenticated;
  sloUrl: string;
  loadingPage$
  showLoadingContentOverlay:boolean = false
  mfacheck$;
  @ViewChildren('scaffoldMenuToggle') scaffoldMenuToggles: QueryList<ElementRef>;
  @ViewChildren('left-menu-button-admin') adminButton: QueryList<ElementRef>;
  public isDarkMode = false;
  constructor(
    private pageTitleService: PageTitleService,
    private loadingPageScreenService:LoadingPageScreenService,
    private translation: TranslationService,
    private translate: TranslateService,
    public dialog: ScaffoldDialogService,
    private mainSidebarService: MainSidebarService,
    private datadogService: DatadogService,
    public iframeService: IframeService,
    private page: PageService,
    private router: Router,
    private userService: UserService,
    private cookieService: CookieService,
    public commenting: CommentingService,
    private properties: PropertiesService,
    public notificationService: NotificationsService,
    public itemsService: ItemsService,
    public environmentService: EnvironmentService,
    private activatedRoute: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private http: HttpClient,
    private overlay: OverlayService,
    private menuListService: MenuListService,
    private intercomService: IntercomService,
    private cognitoDomainService: CognitoDomainService,
    private identityProviderService: IdentityProviderService,
    private webSocketService: WebSocketService,
    private tourService: TourService,
    private viewContainerRef: ViewContainerRef
  ) {

    translate.setDefaultLang("en-US");
  }

  ngOnInit() {
    this.isDarkMode = document.documentElement.classList.contains('dark-theme');
    this.checkToOpenSidebar();
    this.mainSidebarService.updateState(false);
    this.checkForMfaEnabled();
    this.initSocket();
    this.userService.watchAuthenticationCookie();
    this.overlay.open({ overlayStyles: { opacity: ".95" },showSpinner:false }, "translate");
    this.environmentService.setInstanceCookies();

    this.loadingPage$ = this.loadingPageScreenService.loadingPage$.pipe(tap(isLoadingPage =>
      this.showLoadingContentOverlay = isLoadingPage
    ));

    this.initCognitoSSOLogic();
    this.translation
      .loadTranslations(this.translation.browserLanguage)
      .subscribe(() => {
        this.cd.markForCheck();
        this.overlay.close("translate");
      });

    this.translate$ = this.translate.onLangChange.pipe(
      tap(() => {
        {
          const profileText = this.translation.getTranslatedContent(
            "profile",
            "Profile"
          );
          const resetText = this.translation.getTranslatedContent(
            "reset_password",
            "Reset Password"
          );
          const logOutText = this.translation.getTranslatedContent(
            "logout",
            "Logout"
          );
          this.personalMenu = [
            { routerLink: "/profile", label: profileText },
            { routerLink: "/reset-password", label: resetText },
            { label: logOutText, command: () => this.logout(), skipLocationChange: true },
          ];
        }
      })
    );

    this.mainSidebarService.openState$.pipe(delay(500)).subscribe((state) => {
      // avoid this ever being opend from an iframe
      this.sideNavState = this.iframeService.isInIframe?this._navState[0]: state ? this._navState[1] : this._navState[0];
    });
    this.datadogService.init();

    this.properties.watchProperties().subscribe((item) => {
      this.propertiesItem = item;
    });
    this.properties.propertiesDisabledChange().subscribe((status) => {
      this.propertiesDisabled = status;
    });

    if (this.environmentService.environment.suppressLog) {
      if (window) {
        window.console.log = function () {};
      }
    }
    if (!this.environmentService.environment.production) {
      this.env = "Development";
    }
    if (location.toString().match(/\-test/)) {
      this.env = "Test";
    }
    if (Date.now() < 1714226431000) {
      this.notificationService.createBarNotification({
        message:
          "We will be performing scheduled maintenance on April 27th 9:00am to 9:30am New York (EDT) | April 27th 2:00pm to 2:30pm London (BST) | April 27th 11:00pm to 11:30pm Sydney (AEST). The system may be unavailable for a short time during this maintenance period",
        status: "warning",
      });
    }
    // Set up listeners for updates to the different menus
    this.page.hideMenuUpdates().subscribe((hideMenuStatus) => {
      setTimeout(() => {
        this.hideMenu = hideMenuStatus;
      });
    });
    this.setupSideMenu();
    // Setup event listener to page change
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.activatedRoute.queryParams.subscribe((d) => {
          const currentPath = this.router.url.split("?")[0];

          if (currentPath !== this.prevPath) {
            // Generate the content of the Scaffold menu
            this.hideMenu = false;
          }
          this.prevPath = currentPath;
        });
        this.intercomService.updateIntercom();
      });
    this.notificationStatus$ = this.getNotificationStatus();
    this.tourService.registerContainerRef(this.viewContainerRef);

    this.tourService.defineTour('scaffold-theme-setup', [
      { stepId: 'step-1', title: 'Scaffold Menu', content: 'Open the Scaffold menu.', position: 'left', fastForward: true },
      { stepId: 'step-2', title: 'Select Admin', content: 'Select Admin from the navigation menu.', position: 'bottom-center', fastForward: true },
      { stepId: 'step-3', title: 'Select Styling', content: 'Select Styling to style your instance.', position: 'left', fastForward: true},
      { stepId: 'step-4', title: 'Upload Logo', content: 'Upload a logo for your instance.', position: 'bottom', fastForward: false, canSkip: true  },
      { stepId: 'step-5', title: 'Select Colors', content: 'Select the colors for the various elements in your instance.', position: 'top', fastForward: false },
      { stepId: 'step-6', title: 'Review Changes', content: 'Review the look and accessibility of you changes.', position: 'top', fastForward: false, canSkip: true },
      { stepId: 'step-7', title: 'Click Save', content: 'Click the Save button to apply the changes.', position: 'top', fastForward: false },
      { stepId: 'step-8', end: true },
    ]);
    this.tourService.defineTour('create-integration', [
      { stepId: 'step-1', title: 'Scaffold Menu', content: 'Open the Scaffold menu.', position: 'left', fastForward: true },
      { stepId: 'step-2', title: 'Select Imports', content: 'Select Imports from the navigation menu.', position: 'bottom-center', fastForward: true},
      { stepId: 'step-3', title: 'Click New Integration', content: 'Click the New Integration button to open the integration creation page.', position: 'top-center', fastForward: false },
      { stepId: 'step-4', title: 'Enter Details', content: 'Enter the details to your Canvas instance and utility account.', position: 'top-center', fastForward: false },
      { stepId: 'step-5', title: 'Click Verify', content: 'Click the Verify button to verify the integration details.', position: 'left', fastForward: false },
      { stepId: 'step-6', title: 'Enter Friendly Name', content: 'Enter a friendly name for the integration.', position: 'top', fastForward: false },
      { stepId: 'step-7', title: 'Click Save', content: 'Click the Save button to create the integration.', position: 'top', fastForward: false },
      { stepId: 'step-8', end: true },
    ]);
    this.tourService.defineTour('create-import', [
      { stepId: 'step-1', title: 'Scaffold Menu', content: 'Open the Scaffold menu.', position: 'left', fastForward: true },
      { stepId: 'step-2', title: 'Select Imports', content: 'Select Imports from the navigation menu.', position: 'bottom-center', fastForward: true },
      { stepId: 'step-3', title: 'Click New Import', content: 'Click the New Import button to open the import creation page.', position: 'bottom-center', fastForward: false },
      { stepId: 'step-4', title: 'Select Integration', content: 'Select the integration to use for the import.', position: 'right', fastForward: false },
      { stepId: 'step-5', title: 'Select Import Type', content: 'Select how you want to import courses.', position: 'top', fastForward: false },
      { stepId: 'step-6', title: 'Enter Details', content: 'Enter the details for the import.', position: 'top', fastForward: false },
      { stepId: 'step-7', title: 'Click Start Import', content: 'Click the Start Import button to begin importing the courses.', position: 'top', fastForward: false },
      { stepId: 'step-8', end: true },
    ]);
    this.tourService.defineTour('inviting-users',[
      { stepId: 'step-1', title: 'Scaffold Menu', content: 'Open the Scaffold menu.', position: 'left', fastForward: true },
      { stepId: 'step-2', title: 'Select Users & Roles', content: 'Select Users & Roles from the navigation menu.', position: 'left', fastForward: true },
      { stepId: 'step-3', title: 'Click Add Users', content: 'Click the Add Users button to open the user creation page.', position: 'left', fastForward: false },
      { stepId: 'step-4', title: 'Enter Email Address', content: 'Enter the email addresses separated with a comma, for the users you are creating.', position: 'left', fastForward: false },
      { stepId: 'step-5', title: 'Click Process', content: 'Click the Process button to generate the list of users to create.', position: 'left', fastForward: false },
      { stepId: 'step-6', title: 'Confirm User Details', content: 'Confirm the details of the new users and make adjustments as needed.', position: 'left', fastForward: false, canSkip: true },
      { stepId: 'step-7', title: 'Click Create Account', content: 'Click the Create Accounts button to create the new users.', position: 'left', fastForward: false },
      { stepId: 'step-8', end: true },
    ]);

  }

  logout() {
    this.userService.logOut().subscribe((e) => {
      this.sideNavState = this._navState[0];
      // if a cognitoSsoUrl has been set, it should send a logout request to cognito domain, unless user logged in outside of sso at /direct-login. if not a sso enabled instance, go to login page by default
      const authenticatedSso =
        this.cookieService.get("authenticated_sso") === "true";
      const logouturl = this.cognitoSsoUrl
        ? !authenticatedSso || this.avoidSSORedirect
          ? ["/direct-login"]
          : ["/sso/logout"]
        : ["/login"];
      this.router.navigate(logouturl);
    });
  }
  checkToOpenSidebar() {
    const until$ = new Subject();
    combineLatest([
      this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd)
      ),
      this.userService.getLogInState(),
    ])
      .pipe(takeUntil(until$))
      .subscribe(([event, loggedIn]) => {
        const urlAfterRedirects = (event as NavigationEnd).urlAfterRedirects;
        if (
          loggedIn &&
          urlAfterRedirects !== "/login" &&
          urlAfterRedirects !== "/verify-phone-and-email"
        ) {
          this.mainSidebarService.updateState(true);
          until$.next(null);
        }
      });
  }

  initSocket() {
    this.webSocketService.connect().subscribe();
  }

  initCognitoSSOLogic() {

    combineLatest([
      this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd)
      ),
      this.cognitoDomainService.getCognitoSsoUrl$(),
    ])
    .pipe(delay(10))
    .subscribe(
      ([routerState, { cognitoSsoUrl }]: [
        NavigationEnd,
        { cognitoSsoUrl: string }
      ]) => {
        const url = routerState.urlAfterRedirects.split("?")[0];
        this.cognitoSsoUrl = cognitoSsoUrl;
        // avoid displaying login page if meant to redirect
        if (
          url.includes("login") &&
          cognitoSsoUrl &&
          this.cookieService.get("authenticated_sso") === "true" &&
          !this.avoidSSORedirect
        ) {
          this.overlay.open({ overlayStyles: { opacity: ".95" } }, "ssoinit");
        }

        // if it ever comes across direct-login during the session, avoid redirecting to cognito domain for this session
        if (url.includes("direct-login")) {
          this.avoidSSORedirect = true;
          this.overlay.close("ssoinit");
        }

        if (
          this.cognitoSsoUrl &&
          !this.avoidSSORedirect &&
          !url.includes("sso/error")
        ) {
          // avoid setting redirect if sso pages or login pages after authenticated with sso
          if (!url.includes("login") && !url.includes("sso")) {
            localStorage.setItem("redirectUrl", url);
          }

          // let sso pages handle sso logic
          if (
            !url.includes("sso") &&
            this.cookieService.get("authenticated") !== "true"
          ) {
            window.location.href = this.cognitoSsoUrl;
          } else {
            // set to check valid session with idp every 5 minutes and set slo url
            if (!this.initalSsoAuthenticated) {
              // this.identityProviderService.getSloUrl$().subscribe()
              this.initalSsoAuthenticated = true;
              this.userService.startRefreshTokenTimer(5, true);
            }
          }
        }
      }
    );
  }

  /** Toggle the Scaffold navigation menu */
  leftNavtoggle() {
    let cur = this._navState.indexOf(this.sideNavState);
    cur++;
    if (cur >= this._navState.length) {
      cur = 0;
    }
    console.log(cur, this._navState[cur]);
    this.sideNavState = this._navState[cur];
    if(this.sideNavState !== 'collapsed'){
      setTimeout(() => {
        this.tourService.nextStep('scaffold-theme-setup', 'step-1');
      }, 100);
    }

  }


  /**
   * Close the properties sidebar
   * @param e event
   */
  closeProperties(e) {
    if (!e.insideComponent) {
      this.properties.setProperties(null);
    }
  }
  /** Opens notification sidebar
   */
  openNotifications() {
    this.notificationService.showSidebar();
  }

  setInstance({ type, force }) {
    console.log("setInstance", type, force, this.instanceDetails);
    this.environmentService.setSelectedType(type);
    if (this.instanceDetails?.scaffoldType === type) return;
    if (this.router.url === "/home") {
      this.router
        .navigateByUrl("/refresh", { skipLocationChange: true })
        .then(() => {
          this.router.navigate(["/home"]);
        });
    } else {
      if (!force) {
        this.router.navigate(["/home"]);
      }
    }
    this.setupSideMenu();
  }

  setupSideMenu() {
    this.userService.getLogInState().subscribe((loggedIn) => {
      console.log("LOG IN SUB", loggedIn);
      if (!loggedIn) {
        this.mainSidebarService.updateState(false);
        //this.sideNavState = "collapsed";
        //this.crispService.close();
        this.intercomService.shutdownIntercom();

        this.loggedIn = loggedIn;
        // this.sideNavState = "collapsed";
        if (!this.iframeService?.isInIframe) {
          this.intercomService.shutdownIntercom();
        }
      }
      if (loggedIn) {
        let roleData, instanceData;        
        this.environmentService
          .getInstanceDetails(true)
          .pipe(take(1))
          .subscribe((data) => {
            instanceData = data;
            this.instanceDetails = instanceData;
            this.displayAutosave = instanceData.scaffoldType==='designer' || instanceData.scaffoldType==='migration';

            if (instanceData.name) {
              this.pageTitleService.institution = instanceData.name;
            }
            this.userAttributes$ = this.userService
              .getCognitoUserAttributes$()
              .pipe(
                tap((attributes: any) => {
                  if (
                    this?.notifiedUnverifiedEmail ||
                    !attributes?.email ||
                    attributes?.email_verified === true ||
                    this.cognitoSsoUrl
                  )
                    return;
                  this.openUnverifiedNotification(attributes.email);
                })
              );
              this.userService
              .getRoleDetails(true)
              .pipe(take(1))
              .subscribe((data) => {
                roleData = data;
                if (!this.iframeService?.isInIframe) {
                  if (instanceData) {
                    this.intercomService.initializeIntercom({
                      roleData,
                      instanceData,
                    });
                  }
                }else if(this.isDarkMode){
                  // avoid dark mode if in iframe
                  this.toggleTheme()
                }
                this.userInfo = roleData.data;
                this.globalLeftMenuItems = this.menuListService.getGlobalMenu(
                  instanceData,
                  roleData
                );
                this.footerMenu = this.menuListService.getMenuFooter(
                  instanceData,
                  roleData
                );
                this.cd.detectChanges();
              });
          });
      }
    });
  }

  checkForMfaEnabled() {
    // first check if loggedin, if logged in, check instance, if instance is archivev2, check if sso instance, if not sso instance, check if current url, if url is not verify-phone-and-email, check roleDetails, if roleDetails doesnt have mfa_set set as true or is already, allow logic to check for mfa enabled just once during user session, else cancel subscription
    const hasChecked = new Subject();
    this.mfacheck$ = this.userService.getLogInState().pipe(
      switchMap((loggedIn: any) =>
        loggedIn ? this.cognitoDomainService.getCognitoSsoUrl$() : of(null)
      ),
      switchMap((cognito: any) => {
        if (cognito?.cognitoSsoUrl) {
          hasChecked.next(true);
        }
        return cognito && !cognito?.cognitoSsoUrl
          ? this.router.events.pipe(
              filter((event) => event instanceof NavigationEnd)
            )
          : of(null);
      }),
      switchMap((route: any) =>
        route?.url &&
        route.url.indexOf("verify-phone-and-email") === -1 &&
        route.url.indexOf("login") === -1
          ? this.userService.getRoleDetails()
          : of(null)
      ),
      takeUntil(hasChecked),
      delay(10),
      tap((roleDetails) => {
        if (roleDetails?.["data"]?.mfa_set) {
          return hasChecked.next(true);
        }
        if (roleDetails && !roleDetails?.["data"]?.mfa_set) {
          this.userService.checkForMfaEnabled();
          hasChecked.next(true);
        }
      })
    );
  }

  openUnverifiedNotification(email) {
    this.notifiedUnverifiedEmail = true;
    const settings: NotificationMessageData = {
      icon: NotificationMessageIcon.email,
      text: `<strong>Unverified Email:</strong> Do you want to verify ${email} now?`,
      actionText: "Verify",
      action: () => {
        let verifySettings: any = {
          context: {
            data: {
              contactType: "email",
            },
          },
        };
        const dialogRef = this.dialog.open(
          VerifyModalComponent,
          verifySettings
        );
        dialogRef.onClose.subscribe((result) => {
          if (result) {
            this.userInfo["email_verified"] = true;
            this.userService.setUserInfo(this.userInfo);
          }
        });
      },
    };
    this.notificationService.addUserNotification(settings, email);
  }

  getNotificationStatus() {
    return this.notificationService.getNotificationStatus().pipe(
      tap((status: NotificationStatus) => {
        this.activeNotificationCount = status.activeNotificationCount;
      })
    );
  }

  openFooterModal(modal) {
    if (!modal) return;
    switch (modal) {
      /*case "wizard": {
        this.wizardService.openWizard();
      }*/
      case "quick_help": {
        this.dialog.open(QuickHelpComponent, {});
        break
      }
    }
  }

  toggleTheme() {
    const isDarkMode = document.documentElement.classList.contains('dark-theme');
    if (isDarkMode) {
      document.documentElement.classList.remove('dark-theme');
      localStorage.setItem('forceTheme', 'light');
      this.isDarkMode = false;
    } else {
      document.documentElement.classList.add('dark-theme');
      localStorage.setItem('forceTheme', 'dark');
      this.isDarkMode = true;
    }
  }
}
